import { motion } from "framer-motion";
import {
  BarChart3, CalendarDays, CreditCard, FileDown, FileText, Globe,
  GraduationCap, KeyRound, Link2, Magnet, Package, Palette,
  RefreshCcw, Users, Wand2, Zap,
} from "lucide-react";

const FEATURES = [
  [Link2, "Link-in-bio storefront"],
  [FileDown, "Digital downloads"],
  [GraduationCap, "Online courses"],
  [RefreshCcw, "Recurring memberships"],
  [CalendarDays, "Calendar bookings"],
  [Wand2, "Advisor product drafts"],
  [FileText, "Auto sales pages"],
  [Users, "Affiliate program"],
  [CreditCard, "Stripe checkout"],
  [Zap, "Instant delivery"],
  [Package, "Orders & customers"],
  [BarChart3, "Live analytics"],
  [KeyRound, "Pulls from your Vault"],
  [Magnet, "Growth Engine leads"],
  [Palette, "Custom palettes"],
  [Globe, "SEO-ready URLs"],
];

export const MzFeatures = () => (
  <section className="py-20 sm:py-28 bg-[#FAFAFA] border-y border-neutral-100">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mb-12 sm:mb-16"
      >
        <p className="mz-eyebrow mb-3">Everything included</p>
        <h2 className="mz-h text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
          Every feature. <span className="mz-gold-text">On from day one.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3.5 sm:gap-4" data-testid="feature-list">
        {FEATURES.map(([Icon, label], i) => (
          <motion.div
            key={label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-30px" }}
            transition={{ duration: 0.45, delay: (i % 4) * 0.06 }}
            className="flex items-center gap-3 rounded-xl bg-white border border-neutral-100 px-4 py-4 hover:border-[#D4AF37]/50 transition-colors"
          >
            <Icon size={16} className="text-[#AA771C] shrink-0" strokeWidth={1.8} />
            <span className="text-[12.5px] sm:text-[13px] font-medium text-neutral-700">{label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
